import React, { Fragment, useEffect, useRef, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select from 'react-select'
import { OverlayTrigger, Tooltip, Popover } from 'react-bootstrap';
import { toast } from 'react-toastify'

import DeleteModal from 'pages/parts/DeleteModal'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import Rightbar from 'pages/main/cheques/Rightbar'
import Cheque from "../../../components/Cheque"

import html2canvas from 'html2canvas'

import { httpOk, GET, DELETE, PUT, POST, FILE } from 'helpers/api'
import { formatDate, formatMoney, formatMoneyInput, findKeyFromArrayByValue, regexPhoneNumber, checkPermission, chequeNumber, chequeStatusName } from 'helpers/helpers'
import { Link, useLocation, useNavigate } from "react-router-dom"
import { useReactToPrint } from "react-to-print"

import useDidMountEffect from "pages/parts/useDidMountEffect"
import CustomTooltip from "pages/parts/CustomTooltip"
import { SET_CASHBOX } from "store/cashbox/actions"
import { useDispatch, useSelector } from "react-redux"
import ReturnModal from "./Return"

function Index() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const date = new Date()

	const printChequeRef = useRef(null);
	// const isInitialLoad = useRef(true);

	const handlePrint = useReactToPrint({
		content: () => printChequeRef.current,
	});

	// `productImages` OLIB TASHLANDI (2026-08-07): «Guruhlar» ustuni endi
	// rangli belgilar emas, bosqich NOMI ko'rsatadi. Eski ro'yxat faqat
	// «bu turni chizamizmi» degan tekshiruv uchun edi va u total_count = 0
	// bo'lgan turlarni ham o'tkazib yuborardi — natijada har qatorda 3 ta
	// ortiqcha qora belgi chiqardi.

	const statuses = [
		{ 'id': 1, 'name': t('open') },
		{ 'id': 10, 'name': t('closed') },
		{ 'id': -1, 'name': t('deleted') },
	]

	const chequeTypes = [
		{ 'id': 'loyalty', 'name': t('loyalty') },
		{ 'id': 'debt', 'name': t('debt') },
		{ 'id': 'discount', 'name': t('discount') },
		{ 'id': 'bool_no_profit', 'name': t('no_profit') },
		{ 'id': 'bool_no_service_percentage', 'name': t('no_service_percentage') },
		{ 'id': 'organizations', 'name': t('organization') },
	]

	const chequeDates = [
		{ 'id': 'today', 'name': t('today') },
		{ 'id': 'currentWeek', 'name': t('current_week') },
		{ 'id': 'currentMonth', 'name': t('current_month') },
		{ 'id': 'currentYear', 'name': t('current_year') },
		{ 'id': 'yesterday', 'name': t('yesterday') },
		{ 'id': 'lastWeek', 'name': t('last_week') },
		{ 'id': 'lastMonth', 'name': t('last_month') },
		{ 'id': 'lastYear', 'name': t('last_year') },
		{ 'id': 'other', 'name': t('other') }, // Для "Другой..."
	];

	const initialFilter = {
		start_date: formatDate(new Date(), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		chequeDates: "today",
		random: 0,
		search: '',
	};

	const reduxCashbox = useSelector(state => state.cashbox)
	const reduxAccount = useSelector(state => state.account)

	const [cashiers, setCashiers] = useState([])
	const [chequeStatuses, setChequeStatuses] = useState([])
	const [clients, setClients] = useState([])
	const [clientTypes, setClientTypes] = useState([])
	// Kunlik zakaz hajmi (kassa tepasidagi blok) — xodim galochkasi bilan yopiq
	const [dailyVolume, setDailyVolume] = useState(null)
	const canSeeVolume = checkPermission('cashbox.daily_volume')
	const [printData, setPrintData] = useState({})
	// Telegram guruhiga yuborish oynasi
	const [telegramModal, setTelegramModal] = useState({ show: false, item: {}, note: '', mentions: [], sending: false })
	const [tgEmployees, setTgEmployees] = useState([])   // telegram_id bor xodimlar (teglash uchun)
	const [tgData, setTgData] = useState({})             // rasmga aylantiriladigan chek
	const tgChequeRef = useRef(null)                     // off-screen A4 ga havola

	const [modalDelete, setModalDelete] = useState({ show: false })
	const [returnModal, setReturnModal] = useState({ show: false, cheque: {} })
	const [showModal, setShowModal] = useState(false)
	const [showRightBar, setShowRightBar] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(true)

	const [filterData, setFilterData] = useState({ ...initialFilter })
	const [pagination, setPagination] = useState({
		url: '/cheques',
		response: null
	})
	const [data, setData] = useState([])

	async function printCheque(item, a4 = false) {
		const response = await GET(`/cheques/${item.id}`, {}, { loader: true })
		if (httpOk(response)) {
			response.data.a4 = a4;
			setPrintData(response.data);
			setTimeout(() => {
				handlePrint()
			}, 100);
		}
	}

	// ============ CHEKNI TELEGRAM GURUHIGA YUBORISH ============
	// Chek A4 ko'rinishida RASM bo'lib ketadi (tagida chek raqami), sotuvchi izoh yozishi va
	// xodimlarni belgilashi (teglashi) mumkin.
	// ⚠️ html2canvas `display:none` elementni OLMAYDI (Cheque show=false da `d-none` bo'ladi),
	//    shu sababli pastda alohida EKRANDAN TASHQARI (off-screen) A4 render qilinadi.
	async function openTelegramModal(item) {
		// Chekning to'liq ma'lumoti — chop etish bilan bir xil manba
		const response = await GET(`/cheques/${item.id}`, {}, { loader: true })
		if (!httpOk(response)) return

		setTgData({ ...response.data, a4: true })
		setTelegramModal({ show: true, item, note: '', mentions: [], sending: false })

		// Teglash ro'yxati — GURUH ADMINLARI (Telegram to'liq a'zolar ro'yxatini bermaydi,
		// lekin adminlarni to'liq beradi).
		setTgEmployees([])
		const emp = await GET('/helper/telegram-employees', {}, { loader: false })
		if (httpOk(emp)) {
			const list = emp.data ?? []
			setTgEmployees(list)
			// Egasi Sozlamada «avtomat belgilash» qo'ygan odamlar oldindan tanlanadi —
			// sotuvchi esdan chiqarsa ham bo'lim rahbari chekni ko'radi.
			// ⚠️ FAQAT is_default: avval is_manager ham qo'shilgan edi, u lavozim nomidan
			// hisoblanadi va Sozlamadagi galochka bilan O'CHIRIB BO'LMASDI.
			const auto = list.filter((e) => e.is_default).map((e) => e.key)
			// ⚠️ POYGA: ro'yxat kech kelsa, sotuvchi shu vaqtda qo'lda tanlagan bo'lishi mumkin —
			// uni O'CHIRMAYMIZ, faqat hali hech narsa tanlanmagan bo'lsa yozamiz.
			if (auto.length) {
				setTelegramModal((prev) => (prev.mentions.length ? prev : { ...prev, mentions: auto }))
			}
		}
	}

	async function sendTelegramCheque() {
		setTelegramModal((s) => ({ ...s, sending: true }))

		const formData = new FormData()
		formData.append('id', telegramModal.item.id)
		if (telegramModal.note?.trim()) formData.append('note', telegramModal.note.trim())
		// Kalitlar: «tg:<telegram_id>» (guruh a'zosi) yoki «emp:<id>» (xodim)
		telegramModal.mentions.forEach((key) => formData.append('mentions[]', key))

		// A4 chekni rasmga aylantiramiz. Yasay olmasa — backend matnli xabarga o'zi tushadi.
		try {
			if (tgChequeRef.current) {
				const canvas = await html2canvas(tgChequeRef.current, {
					backgroundColor: '#ffffff',
					scale: 2,          // o'qish uchun aniqroq
					useCORS: true,     // logo tashqi manbadan bo'lsa
					logging: false,
					/* ⚠️ QORONG'I MAVZU HIMOYASI.
					   html2canvas TIRIK DOM ning computed rangini oladi. Qorong'i
					   mavzu yoqilgan bo'lsa Telegramga QORA chek rasmi ketardi.
					   `onclone` nusxadan `data-theme` ni olib tashlaydi — shunda
					   birorta qorong'i qoida mos kelmaydi va rasm DOIM oq chiqadi.
					   Ekrandagi ko'rinishga ta'sir qilmaydi (bu faqat nusxa). */
					onclone: (doc) => { doc.documentElement.removeAttribute('data-theme') },
				})
				const blob = await new Promise((res) => canvas.toBlob(res, 'image/png'))
				if (blob) formData.append('photo', blob, `cheque-${telegramModal.item.id}.png`)
			}
		} catch (e) {
			// Rasm yasalmadi — jim o'tamiz, backend matnli variantni yuboradi
		}

		const response = await FILE(`/cheques-send-telegram/${telegramModal.item.id}`, formData, {})
		setTelegramModal((s) => ({ ...s, sending: false }))
		if (httpOk(response)) {
			// FILE() muvaffaqiyat xabarini o'zi ko'rsatmaydi (POST dan farqli) — qo'lda beramiz.
			// Xatolar esa httpStatusChecker orqali toast bo'lib chiqadi (400 -> data.message).
			toast.success(response?.data?.message || t('tg_send'))
			setTelegramModal({ show: false, item: {}, note: '', mentions: [], sending: false })
			setTgData({})
			getData()
		}
	}

	function toggleModalDelete(bool, item = {}) {
		if (bool) {
			setShowRightBar(false)
		}

		setModalDelete({ show: bool, ...item, note: '' })
	}

	async function deleteItem() {
		const response = await DELETE(`/cheques/${modalDelete.id}`, { note: modalDelete.note }, { loader: true })
		if (httpOk(response)) {
			getData()
			toggleModalDelete(false)
		}
	}

	async function changeChequeStatus(item, status) {
		// T13: sotildi (3) va o'chirish (-1) moliyaviy oqibatli — tasodifiy bosishdan himoya (tasdiq so'raymiz)
		if (Number(status) === 3 || Number(status) === -1) {
			const msg = Number(status) === 3 ? t('confirm_close_cheque') : t('confirm_delete_cheque')
			if (!window.confirm(msg)) return
		}
		/* KECHIKISH SABABI — zakaz VA'DADAN KEYIN yopilayotgan bo'lsa, sabab
		   oynasi O'ZI ochiladi. Ilgari bu faqat kichik belgi ortida turardi va
		   prodda 5 oyda BITTA marta ishlatilgan — ya'ni kechikish sabablari
		   haqida ma'lumot yo'q edi. Sotuvni to'smaydi: chek yopiladi, keyin
		   sabab so'raladi (istamasa yopib ketadi). */
		const wasLate = Number(status) === 3 && item.delivery_date
			&& new Date(item.delivery_date).getTime() < Date.now() && !item.late_reason

		const response = await PUT(`/cheques-status`, { id: item.id, status: status }, { loader: true })
		if (httpOk(response)) {
			getData()
			if (wasLate) openLate(item)
		}
	}

	function redirect(item, index) {
		if (item.status === 3) {
			toggleRightbar(true, item, index)
			return;
		}
		navigate(`/cashbox/edit/${item.id}`)
	}

	async function toggleRightbar(boolean = false, item, index) {

		var dataCopy = [...data.data]
		for (let i = 0; i < dataCopy.length; i++) {
			dataCopy[i]['showSidebar'] = false
		}
		if (boolean) {
			const response = await GET(`/cheques/${item.id}`, {}, { loader: true })
			if (httpOk(response)) {
				setSelectedItem(response.data)
				setShowRightBar(boolean)
			}

		} else {
			setShowRightBar(boolean)
			setSelectedItem({})
		}
	}

	async function toggleReturnModal(boolean = false, item, index) {
		if (boolean) {
			const response = await GET(`/cheques/${item.id}`, {}, { loader: true })
			if (httpOk(response)) {
				// if (!response?.data?.products?.filter(item => item.product_type === 1 || (item.product_type === 3 && item.is_prepared))?.length) {
				// 	toast.error('Нет продуктов для возврата');
				// 	setShowModal(false)
				// 	return;
				// }

				setReturnModal({ show: boolean, cheque: response.data })
			}

		} else {
			setReturnModal({ show: boolean, cheque: {} })
		}
	}

	function resetFilter() {
		var filterDataCopy = {
			start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
			end_date: formatDate(new Date(), 'yyyy-MM-dd'),
			status: null,
			cashier_login: null,
			search: '',
			random: filterData.random + 1
		}
		setFilterData(filterDataCopy)
	}

	async function checkFilter() {
		let hasFilter = false;
		for (const key in filterData) {
			if (filterData[key] !== initialFilter[key]) {
				hasFilter = true;
				break;
			}
		}
		setFilterDataExist(hasFilter);
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	function returnClassStatus(status) {
		if (status === 1) {
			return ""
		}
		if (status === 2) {
			return "bg-warning text-white"
		}
		if (status === 3) {
			return "bg-primary text-white"
		}
	}

	function searchWithFilter() {
		checkFilter();

		const params = new URLSearchParams();
		for (const key in filterData) {
			if (filterData[key] !== null && filterData[key] !== '' && filterData[key] !== initialFilter[key]) {
				params.set(key, filterData[key]);
			}
		}
		const newUrl = `${location.pathname}?${params.toString()}`;
		navigate(newUrl);
		setDropdownIsOpen(false)
	}

	async function getData(params) {
		if (!params) {
			params = filterData;
		}
		const response = await GET("/cheques", params, { loader: true });
		if (httpOk(response)) {
			setData(response.data);
			setPagination({ ...pagination, 'url': location.pathname + location.search, 'response': response.data });
		}
	}

	async function getPaymentTypes() {
		const response = await GET('/helper/payment-types')
		// if (httpOk(response)) setPaymentTypes(response.data)
		if (httpOk(response)) dispatch(SET_CASHBOX({ paymentTypes: response.data }))
	}

	async function getChequeStatuses() {
		const response = await GET('/helper/cheques-statuses')
		if (httpOk(response)) { // avval tekshiruv — xato javobda crash bo'lmasin
			// Nom tarjimadan olinadi: baza jadvali global va faqat kirillcha
			// bo'lgani uchun ruscha ishlaydigan xodim ham o'zbekchani ko'rardi.
			const list = response.data.map(s => ({
				...s,
				name: chequeStatusName(t, s.id, s.name),
			}))
			list.unshift({ id: -1, name: t('deleted') });
			setChequeStatuses(list)
		}
	}

	async function getClients() {
		const response = await GET('/helper/clients')
		if (httpOk(response)) setClients(response.data)
	}

	async function getClientTypes() {
		const response = await GET('/helper/clients-types')
		if (httpOk(response)) setClientTypes(response.data)
	}

	/* KUNLIK ZAKAZ HAJMI — bir kunda qancha metr ish olingani.
	   ⚠️ Sana ro'yxatdagi filtr bilan BIR XIL: ekranda ko'rinayotgan cheklar
	      bilan raqam mos bo'lsin (davr tanlansa jami o'sha davr uchun).
	   ⚠️ Bu SOTUV emas, ZAKAZ OLINGANI (chek yozilgan sana bo'yicha). */
	async function getDailyVolume() {
		if (!canSeeVolume) return

		const params = {}
		if (filterData.start_date) params.start_date = filterData.start_date
		if (filterData.end_date) params.end_date = filterData.end_date

		const response = await GET('/cheques-daily-volume', params, { loader: false })
		if (httpOk(response)) setDailyVolume(response.data)
	}

	async function getCashiers() {
		const response = await GET('/helper/cashiers')
		if (httpOk(response)) setCashiers(response.data)
	}

	useEffect(() => {
		getPaymentTypes()
		getChequeStatuses()
		getClients()
		getClientTypes()
		getCashiers()
		// Kvota faqat «Зарур» tugmasi ko'rinadigan tarifda kerak (izoh: tugma yonida).
		// ⚠️ `/urgent-orders/quota` GET ga `section:` middleware QO'YMANG — u sahifa
		//    ochilishida chaqiriladi va 403 toast chiqib qolardi.
		if (checkPermission('sec.production_board')) getUrgentQuota()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const filtersFromUrl = {};
		let hasChangesFromUrl = false;
		params.forEach((value, key) => {
			if (value) {
				filtersFromUrl[key] = value;
				hasChangesFromUrl = true;
			}
		});
		if (hasChangesFromUrl) {
			setFilterData(prev => ({ ...prev, ...filtersFromUrl }));
			getData({ ...initialFilter, ...filtersFromUrl });
		} else {
			// setFilterData(initialFilter);
			getData(initialFilter);
		}
	}, [location.search, navigate]); // eslint-disable-line react-hooks/exhaustive-deps

	useDidMountEffect(() => {
		searchWithFilter()
	}, [filterData.search, filterData.page, filterData.size, filterData.random]) // eslint-disable-line react-hooks/exhaustive-deps

	/* Kunlik hajm — ro'yxat yangilanganda va davr o'zgarganda qayta o'qiladi.
	   `random` — «Qo'llash» bosilganda ortadi, ya'ni filtr bilan birga yangilanadi. */
	useEffect(() => {
		getDailyVolume()
	}, [filterData.start_date, filterData.end_date, filterData.random]) // eslint-disable-line react-hooks/exhaustive-deps

	useDidMountEffect(() => {
		const today = new Date();
		let newStartDate = null;
		let newEndDate = null;

		const getStartOfWeek = (date) => {
			const d = new Date(date);
			const day = d.getDay();
			const diff = d.getDate() - day + (day === 0 ? -6 : 1);
			return new Date(d.setDate(diff));
		};

		const getEndOfWeek = (date) => {
			const d = new Date(date);
			const startOfWeek = getStartOfWeek(d);
			const endOfWeek = new Date(startOfWeek);
			endOfWeek.setDate(startOfWeek.getDate() + 6);
			return endOfWeek;
		};

		switch (filterData.chequeDates) {
			case 'today':
				newStartDate = formatDate(today, 'yyyy-MM-dd');
				newEndDate = formatDate(today, 'yyyy-MM-dd');
				break;
			case 'currentWeek':
				const startOfCurrentWeek = getStartOfWeek(today);
				const endOfCurrentWeek = getEndOfWeek(today);
				newStartDate = formatDate(startOfCurrentWeek, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfCurrentWeek, 'yyyy-MM-dd');
				break;
			case 'currentMonth':
				const startOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
				const endOfCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
				newStartDate = formatDate(startOfCurrentMonth, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfCurrentMonth, 'yyyy-MM-dd');
				break;
			case 'currentYear':
				const startOfCurrentYear = new Date(today.getFullYear(), 0, 1);
				const endOfCurrentYear = new Date(today.getFullYear(), 11, 31);
				newStartDate = formatDate(startOfCurrentYear, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfCurrentYear, 'yyyy-MM-dd');
				break;
			case 'yesterday':
				const yesterday = new Date(today);
				yesterday.setDate(today.getDate() - 1);
				newStartDate = formatDate(yesterday, 'yyyy-MM-dd');
				newEndDate = formatDate(yesterday, 'yyyy-MM-dd');
				break;
			case 'lastWeek':
				const lastWeekEnd = new Date(today);
				lastWeekEnd.setDate(today.getDate() - 7);
				const startOfLastWeek = getStartOfWeek(lastWeekEnd);
				const endOfLastWeek = getEndOfWeek(lastWeekEnd);
				newStartDate = formatDate(startOfLastWeek, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfLastWeek, 'yyyy-MM-dd');
				break;
			case 'lastMonth':
				const startOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
				const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
				newStartDate = formatDate(startOfLastMonth, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfLastMonth, 'yyyy-MM-dd');
				break;
			case 'lastYear':
				const startOfLastYear = new Date(today.getFullYear() - 1, 0, 1);
				const endOfLastYear = new Date(today.getFullYear() - 1, 11, 31);
				newStartDate = formatDate(startOfLastYear, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfLastYear, 'yyyy-MM-dd');
				break;
			case 'other':
				newStartDate = filterData.start_date;
				newEndDate = filterData.end_date;
				break;
			default:
				newStartDate = null;
				newEndDate = null;
				break;
		}

		if (newStartDate !== filterData.start_date || newEndDate !== filterData.end_date) {
			setFilterData(prevFilterData => ({
				...prevFilterData,
				start_date: newStartDate,
				end_date: newEndDate,
			}));
		}
	}, [filterData.chequeDates]); // eslint-disable-line react-hooks/exhaustive-deps

	function getStatusIcon(status) {
		if (status === 1) {
			return "uil-file-plus-alt"
		} else if (status === 2) {
			return "uil-clock"
		} else if (status === 3) {
			return "uil-check-circle"
		}
	}

	const renderTooltip = (props, item) => (
		<Tooltip id="button-tooltip" {...props}>
			{item.name ?
				<>
					{item.name}:
					{item.total_count}
				</>
				:
				item
			}
		</Tooltip>
	);

	const toNumber = (value) => Number(value || 0)

	function getChequeTotalAmount(item = {}) {
		if (item.net_total_amount !== undefined) return toNumber(item.net_total_amount)

		return toNumber(item.total_amount) - toNumber(item.total_returned_amount)
	}

	function getChequeDebtAmount(item = {}) {
		if (item.net_cheque_debt !== undefined) return toNumber(item.net_cheque_debt)

		const chequeDebt = toNumber(item.cheque_debt) - toNumber(item.debt_returned_amount)
		if (item.cheque_debt !== undefined || item.debt_returned_amount !== undefined) {
			return Math.max(chequeDebt, 0)
		}

		return Math.max(toNumber(item.total_amount) - toNumber(item.paid), 0)
	}

	function getChequePaidAmount(item = {}) {
		return Math.max(getChequeTotalAmount(item) - getChequeDebtAmount(item), 0)
	}

	// ── ZARUR (shoshilinch) zakaz ──────────────────────────────────────────────
	// Sotuvchi belgilaydi -> kengashda ustun tepasida qizil «ЗАРУР» yorlig'i bilan
	// turadi va ovozda «Zarur zakaz!» deb aytiladi.
	// Cheklov: har sotuvchiga N ta, AYNI PAYTDA tugamaganlar bo'yicha — chek chiqib
	// ketsa o'rin o'zi bo'shaydi. Hisobni backend yuritadi, bu yerda faqat ko'rsatamiz.
	const [urgentQuota, setUrgentQuota] = useState({ is_enabled: true, unlimited: false, limit: 0, used: 0, left: 0 })

	async function getUrgentQuota() {
		const response = await GET('/urgent-orders/quota')
		if (httpOk(response)) setUrgentQuota(response.data)
	}

	async function toggleUrgent(item) {
		const next = !item.is_urgent
		// SABAB — «nega bu zakaz oldinga o'tdi» degan savol keyin chiqadi.
		// Belgilaganda so'raladi, olib tashlaganda kerak emas.
		let reason = ''
		if (next) {
			reason = window.prompt('Nega zarur? (qisqacha sabab)') || ''
			if (!reason.trim()) return   // bekor qilindi yoki bo'sh — belgilamaymiz
		}
		const response = await PUT(`/urgent-orders/${item.id}`,
			{ is_urgent: next, reason: reason.trim() }, { loader: true })
		if (httpOk(response)) {
			toast.success(next ? t('marked_urgent') : t('urgent_removed'))
			getUrgentQuota()
			searchWithFilter()
		}
		// Kvota tugagan bo'lsa backend 422 + tushuntirish qaytaradi (api.js toast qiladi)
	}

	// ── JARAYON NAZORATI: to'xtatish / davom ettirish / kechikish sababi ──────
	// NEGA SOTUVCHIDA: to'xtatish qarori SOTUVCHIDA tug'iladi («mijoz keyinroq
	// oladi, avval ikkinchisini qiling»). Ilgari bu og'zaki aytilardi, usta
	// to'xtatardi — keyin buyurtma kechikkanda aybdor USTA bo'lib qolardi.
	// Endi to'xtatgan odam o'zi yozadi. Rahbar bu yozuvlarni faqat KO'RADI.
	const [lateModal, setLateModal] = useState({ show: false, item: {}, reason: '', note: '' })
	const [lateReasons, setLateReasons] = useState([])

	async function getLateReasons() {
		const response = await GET('/late-reasons')
		if (httpOk(response)) setLateReasons(response.data)
	}

	/**
	 * TO'XTATISH / DAVOM ETTIRISH - bitta tugma, bitta bosish.
	 *
	 * Sabab SO'RALMAYDI (user qarori): sotuvchi kuniga bir necha marta
	 * to'xtatadi, har safar oyna ochilsa ish sekinlashadi va tugma
	 * ishlatilmay qoladi. Kim to'xtatgani va qancha turgani baribir
	 * yoziladi - nazorat uchun shu yetadi. Batafsil sabab esa buyurtma
	 * haqiqatan KECHIKKANDA so'raladi.
	 */
	async function togglePause(item) {
		// SEX to'xtatgan ishni sotuvchi ocholmaydi (backend ham 403 qaytaradi).
		// Bu tugma o'sha holatda umuman bosilmaydi — bu shunchaki ikkinchi to'siq.
		if (item.is_paused && item.paused_source === 'workshop') {
			toast.error("Buni SEX to'xtatgan — davom ettirishni ham sex qiladi")
			return
		}
		const url = `/cheques/${item.id}/${item.is_paused ? 'resume' : 'pause'}`
		const response = await POST(url, { source: 'seller' }, { loader: true })
		if (httpOk(response)) {
			toast.success(item.is_paused ? 'Davom ettirildi' : "Vaqtincha to'xtatildi")
			searchWithFilter()
		}
	}

	function openLate(item) {
		if (!lateReasons.length) getLateReasons()
		setLateModal({ show: true, item: item, reason: item.late_reason || '', note: '' })
	}

	async function saveLate() {
		if (!lateModal.reason) {
			toast.error("Sababni tanlang")
			return
		}
		const response = await PUT(`/cheques/${lateModal.item.id}/late-reason`,
			{ reason: lateModal.reason, note: lateModal.note }, { loader: true })
		if (httpOk(response)) {
			setLateModal({ show: false, item: {}, reason: '', note: '' })
			searchWithFilter()
		}
	}

	/** Vada o'tib ketganmi — kechikish sababi shundagina so'raladi */
	function isLate(item) {
		if (!item.delivery_date || Number(item.status) >= 3 || Number(item.status) < 1) return false
		return new Date(item.delivery_date).getTime() < Date.now()
	}

	// ── Chek qatoridan to'lov olish (₴) ────────────────────────────────────────
	// Kirim/Chiqimdan farqi: bu chekning O'Z qarzini kamaytiradi (ro'yxatdagi "Туланмаган"
	// darhol yangilanadi) va pulni o'sha zahoti kassaga tushiradi.
	const [paymentModal, setPaymentModal] = useState({ show: false, item: {} })
	// ARALASH TO'LOV: har bir tur uchun alohida summa (naqd 50k + bank 100k + P2P 50k).
	// paymentAmounts = { [payment_type_id]: '50000', ... }
	const [paymentAmounts, setPaymentAmounts] = useState({})
	const [paymentDiscount, setPaymentDiscount] = useState('')
	const [paymentSubmitting, setPaymentSubmitting] = useState(false)

	// TO'LOV TURINI TUZATISH (naqd ↔ bank). Kassir naqdni adashib bankka tushirsa —
	// xato smena yopishda sezilaadi (naqd kam chiqadi). SUMMA o'zgarmaydi, faqat TUR.
	// Faqat ochiq smena (backend ham tekshiradi).
	const [fixTypeModal, setFixTypeModal] = useState({ show: false, item: {} })
	const [fixTypeRows, setFixTypeRows] = useState([])      // chekning ₴ to'lovlari
	const [fixTypeSelected, setFixTypeSelected] = useState(null) // tanlangan ₴ to'lov
	const [fixTypeNewPt, setFixTypeNewPt] = useState(null)  // yangi to'lov turi
	// KO'CHIRILADIGAN summa. Odatda to'liq, lekin QISMAN ham bo'ladi: haydovchi 2 700 000
	// keltirdi, kassir hammasini naqd deb yozdi, sanashda 2 000 000 naqd + 700 000 Click chiqdi.
	// Jami summa har holda o'zgarmaydi — shu sababli bu ham tasnif tuzatish, summa tahriri emas.
	const [fixTypeAmount, setFixTypeAmount] = useState('')
	const [fixTypeNote, setFixTypeNote] = useState('')
	const [fixTypeSubmitting, setFixTypeSubmitting] = useState(false)

	const fixTypeMax = Number(fixTypeSelected?.amount ?? 0)
	const fixTypeMoved = Number(fixTypeAmount || 0)
	const fixTypeRest = fixTypeMax - fixTypeMoved
	const fixTypeValid = fixTypeSelected && fixTypeNewPt && fixTypeMoved > 0
		&& fixTypeMoved <= fixTypeMax && fixTypeNote.trim().length >= 5

	// Faqat HAQIQIY pul: Накд (1) va Банк/P2P (2).
	// Насия (3) — qarz bilan qarzni yopib bo'lmaydi. Скидка (5) — pul emas. Доллар (is_usd) — olib tashlandi.
	const cashPaymentTypes = (reduxCashbox?.paymentTypes || []).filter(p =>
		[1, 2].includes(Number(p.payment_type_category_id)) && !p.is_usd
	)

	const paymentDebt = getChequeDebtAmount(paymentModal.item)
	const paymentEntered = Object.values(paymentAmounts).reduce((s, v) => s + Number(v || 0), 0)
	const paymentDiscountNum = Number(paymentDiscount || 0)
	const paymentLeft = paymentDebt - paymentEntered - paymentDiscountNum

	function togglePaymentModal(show, item = {}) {
		setPaymentAmounts({})
		setPaymentDiscount('')
		setPaymentModal({ show, item })
		setPaymentSubmitting(false)
	}

	async function toggleFixTypeModal(show, item = {}) {
		setFixTypeRows([])
		setFixTypeSelected(null)
		setFixTypeNewPt(null)
		setFixTypeAmount('')
		setFixTypeNote('')
		setFixTypeSubmitting(false)
		setFixTypeModal({ show, item })
		if (!show) return

		const response = await GET(`/cheques/${item.id}/debt-payments`, {}, { loader: true })
		if (httpOk(response)) {
			const rows = response.data?.payments ?? []
			setFixTypeRows(rows)
			// Bitta to'lov bo'lsa o'zi tanlanadi (ko'p holatda shunday)
			const fixable = rows.filter((r) => r.can_fix)
			if (fixable.length === 1) selectFixTypeRow(fixable[0])
		}
	}

	// To'lov tanlanganda ko'chiriladigan summa TO'LIQ qilib to'ldiriladi —
	// odatiy holat to'liq almashtirish, qisman bo'lsa foydalanuvchi kamaytiradi.
	function selectFixTypeRow(row) {
		setFixTypeSelected(row)
		setFixTypeAmount(String(Math.round(Number(row.amount))))
	}

	async function submitFixType() {
		if (!fixTypeValid) return
		setFixTypeSubmitting(true)
		const response = await PUT(`/cheques/${fixTypeModal.item.id}/payment-type`, {
			cheque_payment_id: fixTypeSelected.id,
			payment_type_id: fixTypeNewPt.id,
			amount: fixTypeMoved,
			// Optimistik qulf: biz ko'rgan summa. Bazada boshqa bo'lsa backend 409 qaytaradi —
			// shunda takroriy bosish to'lovni IKKINCHI marta bo'lib qo'ymaydi.
			expected_amount: fixTypeMax,
			note: fixTypeNote.trim(),
		}, { loader: false })
		setFixTypeSubmitting(false)
		if (httpOk(response)) {
			toast.success(`${response.data?.from ?? ''} → ${response.data?.to ?? ''}: ${formatMoney(response.data?.moved ?? 0)}`)
			toggleFixTypeModal(false)
			getData()
		}
	}

	// Bitta turga "qolganini to'ldirish" — boshqa turlarga yozilganini hisobga oladi
	function fillRemaining(ptId) {
		const others = Object.entries(paymentAmounts)
			.filter(([id]) => Number(id) !== Number(ptId))
			.reduce((s, [, v]) => s + Number(v || 0), 0)
		const remaining = Math.max(getChequeDebtAmount(paymentModal.item) - others, 0)
		setPaymentAmounts({ ...paymentAmounts, [ptId]: String(remaining) })
	}

	async function submitPayment() {
		if (paymentSubmitting) return
		if (paymentEntered + paymentDiscountNum <= 0) return toast.error(t('enter_amount'))
		if (paymentEntered + paymentDiscountNum > paymentDebt) return toast.error(t('amount_exceeds_debt'))
		if (!reduxAccount.shift?.id) return toast.error(t('shift_not_opened'))

		const payments = Object.entries(paymentAmounts)
			.map(([id, amount]) => ({ payment_type_id: Number(id), amount: Number(amount || 0) }))
			.filter(p => p.amount > 0)

		setPaymentSubmitting(true)
		const response = await POST(`/cheques/${paymentModal.item.id}/payment`, {
			payments: payments,
			discount: paymentDiscountNum,
			shift_id: reduxAccount.shift.id,
		}, { loader: true, notification: true })

		setPaymentSubmitting(false)
		if (httpOk(response)) {
			togglePaymentModal(false)
			searchWithFilter() // ro'yxat yangilansin — "Туланмаган" kamayadi
		}
	}

	// Tўлов режаси — chek yozilganda belgilangan "pul qanday keladi".
	// Eski cheklarda bo'sh (—) bo'ladi: ular bu maydon qo'shilishidan oldin yozilgan.
	const paymentPlanOptions = [
		{ id: 'cash', name: `💵 ${t('plan_cash')}` },
		{ id: 'half', name: `🧾 ${t('plan_half')}` },
		{ id: 'nasiya', name: `📅 ${t('plan_nasiya')}` },
		{ id: 'driver', name: `🚚 ${t('plan_driver')}` },
	]

	const PAYMENT_PLAN_MAP = {
		cash: { i18n: 'plan_cash', icon: '💵', bg: '#e6f5ee', color: '#1f7a54' },
		half: { i18n: 'plan_half', icon: '🧾', bg: '#fdf4e3', color: '#b7791f' },
		nasiya: { i18n: 'plan_nasiya', icon: '📅', bg: '#fdecea', color: '#c0392b' },
		driver: { i18n: 'plan_driver', icon: '🚚', bg: '#f0e9fa', color: '#7a4bbd' },
	}

	function paymentPlanBadge(plan) {
		const p = PAYMENT_PLAN_MAP[plan]
		if (!p) return <span className="text-muted">—</span>
		return (
			<span style={{
				background: p.bg, color: p.color, fontSize: '11px', fontWeight: 600,
				padding: '2px 6px', borderRadius: '4px', whiteSpace: 'nowrap',
			}}>
				{p.icon} {t(p.i18n)}
			</span>
		)
	}

	// ------------------------------------------------------------------
	// GURUHLAR — ishlab chiqarish bosqichi, endi NOM bilan.
	//
	// Ilgari bu ustun har qatorda 4 ta belgi chizardi, lekin ularning ~58% i
	// chekda UMUMAN YO'Q turlar edi: backend 5 ta turning hammasini
	// total_count = 0 bilan qaytarardi, bu yer esa 0 ni tekshirmasdi.
	// Rangi bo'lmagani uchun ular qop-qora chiqardi — ya'ni ko'z ko'rgan
	// belgilarning ko'pi ma'nosiz edi (2026-08-07).
	//
	// Endi backend faqat mavjud turlarni bosqich nomi bilan qaytaradi:
	//   hammasi bir bosqichda -> o'sha bosqichning O'Z nomi va rangi
	//   aralash               -> eng ORQADAGI bosqich + «oldinga o'tgani/jami»
	// Chek eng sekin zakazni kutadi, shuning uchun aynan orqadagisi.
	// Nomlar tenant sozlamasidan keladi (products_group_statuses) — kodga yozilmaydi.
	// ------------------------------------------------------------------
	function groupSummary(groups) {
		const rows = (groups || []).filter(g => Number(g.total_count) > 0)
		if (!rows.length) return null

		// Bosqich UMUMAN belgilanmagan bo'lsa yorliq ham, oyna ham chiqmasin —
		// oddiy «—» yetadi. Hamma tenant kengashni ishlatavermaydi: lokal bazada
		// `nayman2026` ning 2 728 ta zakazida `group_status` NULL (2026-08-07).
		if (!rows.some(g => g.stage_name)) return null

		const orderOf = g => Number(g.stage_order ?? 0)
		const total = rows.reduce((s, g) => s + Number(g.total_count), 0)

		let lowest = rows[0]
		for (const g of rows) {
			if (orderOf(g) < orderOf(lowest)) lowest = g
		}
		const ahead = rows
			.filter(g => orderOf(g) > orderOf(lowest))
			.reduce((s, g) => s + Number(g.total_count), 0)

		return {
			name: lowest.stage_name || '—',
			color: lowest.color || '#adb5bd',
			mixed: ahead > 0,
			ahead,
			total,
		}
	}

	// Katakni bosganda ochiladi: chek ichidagi HAR BIR zakazning qadamlari —
	// qaysi biri bo'lgan (✓), qayerda turibdi (●), qaysi biri hali yo'q (○).
	function stepsPopover(item) {
		const stages = data?.group_stages || []
		const rows = (item.groups || []).filter(g => Number(g.total_count) > 0)

		return (
			<Popover id={`cb-steps-${item.id}`} className="cb-steps-pop">
				<Popover.Header as="h6">
					<b>#{chequeNumber(item)}</b> — {item.client_name}
				</Popover.Header>
				<Popover.Body>
					{rows.map((g, i) => {
						const cur = Number(g.stage_order ?? 0)
						return (
							<div className="cb-steps-item" key={i}>
								<div className="cb-steps-name">
									{g.name}
									{Number(g.total_count) > 1 && <span className="text-muted"> ×{g.total_count}</span>}
								</div>
								<div className="cb-track">
									{stages.map((s, si) => {
										// `eff_order` — backendda QAYTA hisoblangan tartib.
										// Xom `order_number` ba'zi tenantlarda NULL (maxprof,
										// nayman2026) — u holda hamma qadam «hozir shu yerda»
										// bo'lib chiqardi (2026-08-07).
										const done = Number(s.eff_order) < cur
										const now = Number(s.eff_order) === cur
										return (
											<Fragment key={si}>
												{si > 0 && <span className={'cb-bar' + (done || now ? ' on' : '')}></span>}
												<span className={'cb-step' + (now ? ' now' : (done ? ' done' : ''))}
													style={{ '--sc': s.color || '#adb5bd' }}>
													<i>{done ? '✓' : (now ? '●' : '○')}</i>
													<em>{s.name}</em>
												</span>
											</Fragment>
										)
									})}
								</div>
							</div>
						)
					})}
					{!rows.length && <div className="text-muted">{t('no_data')}</div>}
				</Popover.Body>
			</Popover>
		)
	}

	function getTotalAmount(data = {}) {
		if (data.net_total_amount !== undefined) return toNumber(data.net_total_amount)

		return toNumber(data.total_amount) - toNumber(data.total_returned_amount)
	}

	return (
		<>
			<div className="page-header d-between mb-2">
				<h4 className="vertical-center">
					{t('cheques')} [{data?.total}]
				</h4>

				<Link to="/cashbox/create" className="btn btn-primary" onClick={() => dispatch({ type: 'SET_CHEQUE_DATA', payload: {} })}>
					{t('create')}
				</Link>
			</div>

			{/* ═══ KUNLIK ZAKAZ HAJMI ═══
			    «Bir kunda necha metr profnastil, aksessuar, tunukafon zakaz olingani»
			    ⚠️ Bu SOTUV emas — chek YOZILGAN sana bo'yicha, ya'ni sexga qancha ish
			       tushgani. Sotuv hisobotlari yopilish sanasi bo'yicha ishlaydi.
			    ⚠️ Sana ro'yxatdagi filtr bilan bir xil: davr tanlansa jami o'sha davr uchun. */}
			{(canSeeVolume && dailyVolume) &&
				<div className="d-flex flex-wrap gap-2 mb-3">
					{dailyVolume.items.map((it) => (
						<div key={it.product_type} className="card mb-0" style={{ flex: '1 1 200px' }}>
							<div className="card-body py-2 px-3">
								<div className="d-flex justify-content-between align-items-center">
									<span className="text-muted fz-14">{it.name}</span>
									<span className="text-muted fz-14">{it.cheques} {t('pieces')}</span>
								</div>
								<div className="fw-bold" style={{ fontSize: '1.15rem' }}>
									{formatMoney(it.volume)} <span className="text-muted fz-14">{it.unit}</span>
								</div>
							</div>
						</div>
					))}
					<div className="vertical-center text-muted fz-14 ps-1">
						{dailyVolume.is_today
							? t('today')
							: `${formatDate(dailyVolume.start_date)} — ${formatDate(dailyVolume.end_date)}`}
					</div>
				</div>
			}

			<div className="card">
				<div className="card-body">

					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('cashier')}</label>
												<Select
													options={cashiers}
													value={cashiers.find(option => option.login === filterData?.cashier_login) || ''}
													// value={filterData.cashiers}
													onChange={(option) => setFilterData({ ...filterData, cashier_login: option?.login })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.login}
													isClearable
												// isMulti
												/>
											</div>

											<div className="form-group col-md-6">
												<label>{t('clients')}</label>
												<Select
													isClearable
													options={clients}
													value={clients.find(option => option.id === Number(filterData.client_id)) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'client_id': option?.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											{/* MIJOZ TURI — Usta / Quruvchi / Uy egasi / Listchi.
											    Tur mijoz kartochkasida saqlanadi, chekda emas. */}
											<div className="form-group col-md-6">
												<label>{t('client_type')}</label>
												<Select
													isClearable
													options={clientTypes}
													value={clientTypes.find(option => option.id === Number(filterData.client_type_id)) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'client_type_id': option?.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-6">
												<label>{t('payment')}</label>
												<Select
													isClearable
													options={reduxCashbox?.paymentTypes}
													value={reduxCashbox?.paymentTypes?.find(option => option.id === Number(filterData.payment_type_id)) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'payment_type_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={chequeStatuses}
													value={chequeStatuses.find(option => option.id === Number(filterData.status)) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'status': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											{/* Tўлов режаси bo'yicha filtr — "shofyordan olinadiganlar", "nasiyalar" ni topish uchun */}
											<div className="form-group col-md-6">
												<label>{t('payment_plan')}</label>
												<Select
													isClearable
													options={paymentPlanOptions}
													value={paymentPlanOptions.find(option => option.id === filterData.payment_plan) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'payment_plan': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-6">
												<label>{t('cheque')} ID</label>
												<input type="text" className="form-control" value={filterData.id}
													onChange={(e) => setFilterData({ ...filterData, 'id': e.target.value })} />
											</div>
											<div className="form-group col-md-6">
												<label>{t('shift')} ID</label>
												<input type="text" className="form-control" value={filterData.shift_id}
													onChange={(e) => setFilterData({ ...filterData, 'shift_id': e.target.value })} />
											</div>
											<div className="form-group col-md-6">
												<label>{t('client')} {t('phone')}</label>
												<input type="text" className="form-control" value={filterData.client_phone}
													onChange={(e) => setFilterData({ ...filterData, 'client_phone': e.target.value })} />
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-4">
												<label>{t('period')}</label>
												<Select
													options={chequeDates}
													value={chequeDates.find(option => option.id === filterData.chequeDates) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'chequeDates': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-4">
												<label className="invisible">{t('period')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-4">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.end_date ? new Date(filterData.end_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => searchWithFilter()}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
						<div className="vertical-center">
							<h4 className="text-end">
								<b>{t('amount')}</b>: {formatMoney(getTotalAmount(data))}
							</h4>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterData.status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{findKeyFromArrayByValue(statuses, 'id', filterData.status, 'name')}
									</span>
								}
								{filterData.cheque_type &&
									<span className="me-2">
										<b>{t('cheque_type')}: </b>
										{findKeyFromArrayByValue(chequeTypes, 'id', filterData.cheque_type, 'name')}
									</span>
								}
								{filterData.cashier_login &&
									<span className="me-2">
										<b>{t('cashier')}: </b>
										{findKeyFromArrayByValue(cashiers, 'login', filterData.cashier_login, 'first_name')}
									</span>
								}
								{filterData.id &&
									<span className="me-2">
										<b>ID: </b> {filterData.id}
									</span>
								}
								{filterData.shift_id &&
									<span className="me-2">
										<b>{t('shift')} ID: </b> {filterData.shift_id}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={() => resetFilter()}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									{/* USTUNLAR TARTIBI — 2026-08-07 da foydalanuvchi belgilagan.
									    Olib tashlandi: Kuryer (3 oyda 1 ta chekda to'lgan), Smena №
									    (filtrda bor), Mijoz turi (lug'ati buzuq — Usta/usta takror),
									    Yopilgan sana (T1 tufayli 1-iyuldan beri 90% bo'sh).
									    Qo'shildi: Vada va Ochilgan — ikkalasi ham backendda bor edi,
									    lekin ekranga chiqmasdi. */}
									{/* Tartib raqami — global (sahifa 2 da 21 dan boshlanadi),
									    backend `row_number` beradi. */}
									<th style={{ 'minWidth': '38px' }} className="text-center">№</th>
									<th style={{ 'width': '7%' }}>{t('cashier')}</th>
									<th style={{ 'width': '15%' }}>{t('client')}</th>
									<th style={{ 'width': '9%', 'minWidth': '130px' }} className="text-center">{t('phone')}</th>
									{/* Holat / Guruhlar / To'lov rejasi — QISQA ustunlar: ularning
									    ichi yorliq, kengaytirishning ma'nosi yo'q. Bo'shagan joy
									    mijoz, pul va sana ustunlariga beriladi (2026-08-07). */}
									<th style={{ 'width': '1%', 'minWidth': '76px' }} className="text-center">{t('status')}</th>
									<th style={{ 'width': '1%', 'minWidth': '104px' }} className="text-center">{t('groups')}</th>
									<th style={{ 'width': '9%', 'minWidth': '118px' }} className="text-center">{t('promise_date')}</th>
									<th style={{ 'width': '1%', 'minWidth': '94px' }} className="text-center">{t('payment_plan')}</th>
									<th style={{ 'width': '8%' }} className="text-end td-ellipsis">{t('paid')}</th>
									<th style={{ 'width': '8%' }} className="text-end td-ellipsis">{t('not_paid')}</th>
									<th style={{ 'width': '8%' }} className="text-end">{t('amount')}</th>
									<th style={{ 'width': '9%', 'minWidth': '125px' }} className="text-center">{t('open_date')}</th>
									<th style={{ 'width': '5%', 'minWidth': '82px' }} className="text-center td-ellipsis">{t('cheque')} №</th>
									<th style={{ 'minWidth': '33px' }} className="text-center"></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<Fragment key={index}>
										<tr className={`cursor ${item.showSidebar ? 'table-tr-active' : ''}`} onClick={() => redirect(item, index)}>
											<td className="text-center text-muted">{item.row_number}</td>
											<td className="td-ellipsis">
												<CustomTooltip text={item.cashier_name}>
													{item.cashier_name}
												</CustomTooltip>
											</td>
											<td className="td-ellipsis">
												<CustomTooltip text={item.client_name}>
													{item.client_name}
												</CustomTooltip>
											</td>
											<td className="text-center">
												<CustomTooltip text={regexPhoneNumber(item.client_phone)}>
													{regexPhoneNumber(item.client_phone)}
												</CustomTooltip>
											</td>
											<td className={`text-center cb-status ${returnClassStatus(item.status)}`}>
												{findKeyFromArrayByValue(chequeStatuses, 'id', item.status, 'name')}
											</td>
											<td className="text-center">
												{(() => {
													const g = groupSummary(item.groups)
													if (!g) return <span className="text-muted">—</span>
													return (
														<OverlayTrigger trigger="click" rootClose placement="auto"
															overlay={stepsPopover(item)}>
															<span className={'cb-group' + (g.mixed ? ' is-mixed' : '')}
																title={t('show_stages')}
																onClick={(e) => e.stopPropagation()}>
																<span className="cb-group-dot" style={{ background: g.color }}></span>
																<span className="cb-group-name">{g.name}</span>
																{g.mixed && <span className="cb-group-frac">{g.ahead}/{g.total}</span>}
															</span>
														</OverlayTrigger>
													)
												})()}
											</td>
											{/* VADA — backend allaqachon yuborardi (delivery_date), lekin
											    ekranga chiqmasdi: faqat «kechikish» tugmasi uchun ishlatilardi.
											    Qizil = kechikkan, sariq = bugun. Yopilgan chekda rangsiz. */}
											<td className="text-center">
												{item.delivery_date
													? <span className={'cb-vada' + (
														Number(item.status) >= 3 ? ''
															: isLate(item) ? ' is-late'
																: (formatDate(item.delivery_date, 'yyyy-MM-dd') === formatDate(new Date(), 'yyyy-MM-dd') ? ' is-today' : '')
													)}>
														{formatDate(item.delivery_date, 'dd.MM.yyyy HH:mm')}
													</span>
													: <span className="text-muted">—</span>
												}
											</td>
											<td className="text-center">
												{paymentPlanBadge(item.payment_plan)}
											</td>
											<td className={`text-end text-nowrap`}>
												{formatMoney(getChequePaidAmount(item))}
											</td>
											{/* Qarz signali ENDI shu yerda. Ilgari «Ochilgan sana» katagi
											    qizil bo'lardi — ya'ni sana ustuni pul haqida gapirardi. */}
											<td className={`text-end text-nowrap${getChequeDebtAmount(item) > 0 ? ' cb-debt' : ''}`}>
												{formatMoney(getChequeDebtAmount(item))}
											</td>
											<td className={`text-end text-nowrap`}>
												{formatMoney(getChequeTotalAmount(item))}
											</td>
											<td className="text-center text-nowrap">
												{formatDate(item.cheque_opened_at, 'dd.MM.yyyy HH:mm')}
											</td>
											<td className="td-ellipsis text-center" title={item.id}>
												{/* Ro'yxat va CHOP ETISH bir xil raqam ko'rsatishi uchun
												    yagona funksiya — ilgari ikki joyda ikki xil edi va
												    chop etilgan chekda boshqa raqam chiqardi (2026-08-06). */}
												<CustomTooltip text={item.id}>
													#{chequeNumber(item)}
												</CustomTooltip>
											</td>
											<td className="py-0" style={{ verticalAlign: 'middle' }}>
												<div className="d-flex justify-content-end gap-1">

													{/* ZARUR belgilash. Yopilgan/o'chirilgan chekda ko'rsatilmaydi —
													    ishlab chiqarish tugagan, shoshiltirishning ma'nosi yo'q.
													    Kvota tugagan bo'lsa tugma umuman chiqmaydi, lekin BEKOR qilish
													    har doim mumkin (o'rin bo'shatish bloklanmasligi kerak). */}
													{/* Yopilganlik STATUS bilan aniqlanadi: `cheque_closed_at` ishonchsiz
													    (processUpdate() unga tegmaydi — CLAUDE.md T1), shuning uchun
													    yopilgan chekda ham tugma chiqib qolardi. */}
													{/* ⚠️ КЕНГАШ ruxsatiga bog'landi (2026-08-13).
													    «Зарур» belgisining BUTUN ma'nosi Кенгашda: navbat
													    saralash, ЗАРУР yorlig'i, ovoz, ish topshirig'idagi ⚡.
													    Кенгаш Pro imkoniyati, ya'ni Startda sotuvchi tugmani
													    bosardi, sabab yozardi, KVOTA SARFLANARDI — natija esa
													    hech qayerda ko'rinmasdi (kassa ro'yxati id bo'yicha
													    saralanadi, zarur zakaz tepaga chiqmaydi). Ustiga
													    Start egasi buni o'chira ham olmasdi:
													    `sec.urgent_settings` ham Pro/Full da. */}
													{checkPermission('sec.production_board') &&
														urgentQuota.is_enabled && item.status > 0 && Number(item.status) < 3 &&
														(item.is_urgent || urgentQuota.unlimited || urgentQuota.left > 0) &&
														<div className="table-dropdown-item" onClick={(e) => {
															e.stopPropagation();
															toggleUrgent(item);
														}}>
															<OverlayTrigger overlay={(props) => renderTooltip(props,
																item.is_urgent ? t('urgent_remove')
																	: `${t('mark_urgent')}${urgentQuota.unlimited ? '' : ` (${urgentQuota.left})`}`)}>
																<i className="uil-bolt" style={{ color: item.is_urgent ? '#e11d48' : '#adb5bd' }}></i>
															</OverlayTrigger>
														</div>
													}

													{/* TO'XTATISH / DAVOM ETTIRISH — holati RANG bilan ko'rinadi:
													    kulrang = ishlayapti · sariq = sotuvchi to'xtatgan (bosib ochiladi)
													    · binafsha = SEX to'xtatgan (sotuvchi ocholmaydi, faqat ko'radi).
													    Ilgari ikkala holat ham xira belgi edi va farqi bilinmasdi. */}
													{item.status > 0 && Number(item.status) < 3 &&
														<div className={'table-dropdown-item cb-pause'
																+ (item.is_paused ? (item.paused_source === 'workshop' ? ' is-shop' : ' is-held') : '')}
															onClick={(e) => {
																e.stopPropagation();
																togglePause(item);
															}}>
															<OverlayTrigger overlay={(props) => renderTooltip(props,
																!item.is_paused ? "Vaqtincha to'xtatish"
																	: item.paused_source === 'workshop'
																		? `SEX to'xtatgan${item.pause_reason ? ': ' + item.pause_reason : ''} — ochishni sex qiladi`
																		: 'Siz to\'xtatgansiz — davom ettirish')}>
																<i className={item.is_paused
																	? (item.paused_source === 'workshop' ? 'uil-pause-circle' : 'uil-play-circle')
																	: 'uil-pause-circle'} />
															</OverlayTrigger>
														</div>
													}

													{/* KECHIKKAN - sababini SOTUVCHI yozadi.
													    Sabab yozilmagan bo'lsa qizil, yozilgan bo'lsa sariq. */}
													{isLate(item) &&
														<div className="table-dropdown-item" onClick={(e) => {
															e.stopPropagation();
															openLate(item);
														}}>
															<OverlayTrigger overlay={(props) => renderTooltip(props,
																item.late_reason ? 'Kechikish sababi yozilgan' : 'Kechikish sababini yozing')}>
																<i className={item.late_reason ? 'uil-info-circle' : 'uil-question-circle'}
																	style={{ color: item.late_reason ? '#d97706' : '#dc3545' }}></i>
															</OverlayTrigger>
														</div>
													}

													{/* To'lov olish — faqat qarzi bor cheklarda yonadi.
													    Kirim/Chiqimdan mijoz qidirish shart emas: chek ham, mijoz ham ma'lum. */}
													{getChequeDebtAmount(item) > 0 && item.status !== -1 && checkPermission('cashbox.cheque_payment') &&
														<div className="table-dropdown-item" onClick={(e) => {
															e.stopPropagation();
															togglePaymentModal(true, item);
														}}>
															<OverlayTrigger overlay={(props) => renderTooltip(props, t('take_payment'))}>
																<i className="uil-money-bill" style={{ color: '#198754' }}></i>
															</OverlayTrigger>
														</div>
													}

													{/* TO'LOV TURINI TUZATISH — kassir naqdni adashib bankka tushirsa.
													    Qarz 0 bo'lganda ₴ tugmasi yo'qoladi, lekin xato tur qolib ketadi —
													    shu sababli bu tugma qarzga BOG'LIQ EMAS, ₴ to'lov borligiga bog'liq.
													    Summa o'zgarmaydi, faqat naqd↔bank. Faqat ochiq smenada (backend tekshiradi). */}
													{Number(item.debt_payments_count) > 0 && item.status !== -1 && checkPermission('cashbox.fix_payment_type') &&
														<div className="table-dropdown-item" onClick={(e) => {
															e.stopPropagation();
															toggleFixTypeModal(true, item);
														}}>
															<OverlayTrigger overlay={(props) => renderTooltip(props, t('fix_payment_type'))}>
																<i className="uil-exchange" style={{ color: '#b7791f' }}></i>
															</OverlayTrigger>
														</div>
													}

													{/* QO'SHIMCHA ZAKAZ. Sharti ilgari faqat `!parent_id` edi —
													    shuning uchun SOTILGAN va hatto O'CHIRILGAN chekda ham
													    chiqardi. Yopilgan chekka zakaz qo'shishning ma'nosi yo'q. */}
													{!item.parent_id && item.status > 0 && Number(item.status) < 3 &&
														<div className="table-dropdown-item" onClick={(e) => {
															e.stopPropagation();
															navigate('/cashbox/create', {
																state: {
																	parent_id: Number(item.id),
																	client_id: item.client_id,
																	delivery_type_id: item.delivery_type_id,
																	address: item.address,
																}
															});
														}}>
															<OverlayTrigger overlay={(props) => renderTooltip(props, "Qo'shimcha zakaz")}>
																<i className="uil-plus-circle" style={{ color: '#d97706' }}></i>
															</OverlayTrigger>
														</div>
													}

													<span className="cb-act-sep"></span>

													<div className="table-dropdown-item " onClick={(e) => e.stopPropagation() + toggleRightbar(true, item, index)}>
														<OverlayTrigger overlay={(props) => renderTooltip(props, t('preview'))}>
															<i className="uil-eye"></i>
														</OverlayTrigger>
													</div>
													<div className="table-dropdown-item " onClick={(e) => e.stopPropagation() + printCheque(item)}>
														<OverlayTrigger overlay={(props) => renderTooltip(props, `${t('print')} 80mm`)}>
															<i className="uil-print"></i>
														</OverlayTrigger>

													</div>
													{/* A4 belgisi ilgari 80mm bilan AYNAN bir xil edi (ikkala joyda
													    `uil-print`), farqi faqat tooltipda — yonma-yon turgani uchun
													    xato bosish kafolatlangan edi. */}
													<div className="table-dropdown-item " onClick={(e) => e.stopPropagation() + printCheque(item, true)}>
														<OverlayTrigger overlay={(props) => renderTooltip(props, `${t('print')} A4`)}>
															<i className="uil-file-alt"></i>
														</OverlayTrigger>
													</div>

													{/* ⚠️ Yonidagi tugmalar gated, bu esa emas edi (2026-08-13).
													    Startda bosilsa modal ochilib, adminlar ro'yxati bo'sh
													    chiqardi va «Yuborish» 400 bilan tarifi YOPGAN sahifaga
													    yo'naltirardi. Backend marshruti ham shu bilan birga
													    yopildi (api.php: cheques-send-telegram). */}
													{checkPermission('sec.telegram_settings') &&
														<div className="table-dropdown-item " onClick={(e) => e.stopPropagation() + openTelegramModal(item)}>
															<OverlayTrigger overlay={(props) => renderTooltip(props, t('send_telegram'))}>
																<i className="uil-telegram-alt"></i>
															</OverlayTrigger>
														</div>}

													<span className="cb-act-sep"></span>

													{(item.status === 3 && checkPermission('cashbox.return_cheque')) &&
														<div className="table-dropdown-item " onClick={(e) => e.stopPropagation() + toggleReturnModal(true, item, index)}>
															<OverlayTrigger overlay={(props) => renderTooltip(props, t('return'))}>
																<i className="uil-backward"></i>
															</OverlayTrigger>
														</div>
													}

													{item.status > 0 &&
														<>

															{(item.status !== 3 && checkPermission('cashbox.delete_cheque')) &&
																<div className="table-dropdown-item " onClick={(e) => e.stopPropagation() + toggleModalDelete(true, item)}>
																	<OverlayTrigger overlay={(props) => renderTooltip(props, t('cancel_cheque'))}>
																		<i className="uil-times-circle"></i>
																	</OverlayTrigger>
																</div>
															}

															{item.status !== 3 &&
																chequeStatuses.map((item2, index2) => (
																	(item2.id !== item.status) && item2.id > 0 &&
																	<div key={index2} onClick={(e) => e.stopPropagation() + changeChequeStatus(item, item2.id)} className={`table-dropdown-item  ga`}>
																		<OverlayTrigger overlay={(props) => renderTooltip(props, item2.name)}>
																			<i className={`${getStatusIcon(item2.id)}`}></i>
																		</OverlayTrigger>
																	</div>
																))
															}
														</>
													}
												</div>
											</td>
											{/* <td>
												<div className="table-dropdown">
													<Dropdown id={`dropdown-${index}`}>
														<Dropdown.Toggle variant="outline-primary">
															<i className="uil uil-ellipsis-v"></i>
														</Dropdown.Toggle>

														<Dropdown.Menu>
															<div className="table-dropdown-item" onClick={() => toggleRightbar(true, item, index)}>
																<i className="uil-eye"></i>
																{t('preview')}
															</div>
															<div className="table-dropdown-item" onClick={() => printCheque(item)}>
																<i className="uil-print"></i>
																{t('print')}
															</div>

															<div className="table-dropdown-item" onClick={() => printCheque(item, true)}>
																<i className="uil-print"></i>
																{t('print')} A4
															</div>

															{item.status !== 3 &&
																chequeStatuses.map((item2, index2) => (
																	item2.id !== item.status &&
																	<div key={index2} onClick={() => changeChequeStatus(item, item2.id)} className="table-dropdown-item">
																		{item2.name}
																	</div>
																))
															}
														</Dropdown.Menu>
													</Dropdown>
												</div>
											</td> */}
										</tr>
										{/* <tr key={index}>
											<td colSpan="13" className="py-0" style={{ verticalAlign: 'middle' }}>
												<div className="d-between">
													<div className="d-flex gap-2">
														{item.groups.map((item2, index2) => (
															<div className="px-2" key={index2}>
																{item2.name}:
																{item2.total_count}
															</div>
														))
														}
													</div>

													<div className="d-flex justify-content-end gap-3">
														<div className="table-dropdown-item" onClick={() => toggleRightbar(true, item, index)}>
															<b>
																<i className="uil-eye me-1"></i>
																{t('preview')}
															</b>
														</div>
														<div className="table-dropdown-item" onClick={() => printCheque(item)}>
															<b>
																<i className="uil-print me-1"></i>
																{t('print')}
															</b>
														</div>
														<div className="table-dropdown-item" onClick={() => printCheque(item, true)}>
															<b>
																<i className="uil-print me-1"></i>
																{t('print')} A4
															</b>
														</div>
														<div className="table-dropdown-item" onClick={() => openTelegramModal(item)}>
															<b>
																<i className="uil-telegram-alt me-1"></i>
																{t('send_telegram')}
															</b>
														</div>
														{item.status !== 3 &&
															chequeStatuses.map((item2, index2) => (
																item2.id !== item.status &&
																<div key={index2} onClick={() => changeChequeStatus(item, item2.id)} className={`table-dropdown-item gap-0`}>
																	<i className={`${getStatusIcon(item2.id)} me-1`}></i>
																	{item2.name}
																</div>
															))
														}
													</div>
												</div>
											</td>
										</tr> */}
									</Fragment>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL ADDITIONAL INFO */}
			<Modal
				show={showModal} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('additional_info')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('guests')}</span>
						<span>{data.total_people_number}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')}</span>
						<span>{data.total}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('hall')} ]</span>
						<span>{data.total_hall}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('takeaway')} ]</span>
						<span>{data.total_takeaway}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('delivery')} ]</span>
						<span>{data.total_delivery}</span>
					</div>
					<div className="d-flex justify-content-between mb-1 ms-3">
						<span>{t('number_of_checks')} [ {t('manager')} ]</span>
						<span>{data.total_delivery_manager}</span>
					</div>
					<div className="d-flex justify-content-between mb-1 ms-3">
						<span>{t('number_of_checks')} [ {t('telegram')} ]</span>
						<span>{data.total_delivery_telegram}</span>
					</div>
					<div className="d-flex justify-content-between mb-1 ms-3">
						<span>{t('number_of_checks')} [ {t('call_center')} ]</span>
						<span>{data.total_delivery_call_center}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('deleted')} ]</span>
						<span>{data.total_deleted}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('discount')} ]</span>
						<span>{data.total_discount}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('agents')} ]</span>
						<span>{data.total_agents}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('debt')} ]</span>
						<span>{data.total_debtor}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('no_profit')} ]</span>
						<span>{data.total_no_profit}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('no_service_percentage')} ]</span>
						<span>{data.total_no_service_percentage}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('discount')}</span>
						<span>{formatMoney(data.total_discount)}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('delivery')}</span>
						<span>{formatMoney(data.total_delivery_price)}</span>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL ADDITIONAL INFO */}

			<DeleteModal
				showNote={true}
				modalDelete={modalDelete}
				setModalDelete={toggleModalDelete}
				setNote={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>

			<Rightbar
				showRightBar={showRightBar}
				setShowRightBar={setShowRightBar}
				toggleModalDelete={toggleRightbar}
				selectedItem={selectedItem}>
			</Rightbar>

			<Cheque data={printData} printChequeRef={printChequeRef} />

			{/* Telegram uchun A4 chek — EKRANDAN TASHQARIDA, lekin RENDER QILINGAN.
			    `d-none` (display:none) bo'lsa html2canvas bo'sh rasm qaytaradi, shuning uchun
			    ko'rinmas holatga chapga surib qo'yamiz. Foydalanuvchi buni ko'rmaydi. */}
			<div style={{ position: 'fixed', left: '-10000px', top: 0, width: '900px', background: '#fff', zIndex: -1 }} aria-hidden="true">
				{telegramModal.show && tgData?.id &&
					<Cheque data={tgData} printChequeRef={tgChequeRef} show={true} />
				}
			</div>

			{/* Chekni Telegram guruhiga yuborish */}
			<Modal show={telegramModal.show} animation={false} centered size="lg"
				onHide={() => setTelegramModal({ show: false, item: {}, note: '', mentions: [], sending: false })}>
				<Modal.Header closeButton>
					<Modal.Title>
						<i className="uil-telegram-alt me-2 text-primary"></i>
						{t('send_telegram')} — № {telegramModal.item?.id}
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<div className="alert alert-light py-2 mb-3" style={{ fontSize: '12.5px' }}>
						<i className="uil-image me-1 text-primary"></i>{t('tg_image_note')}
					</div>

					<div className="form-group mb-3">
						<label className="form-label">{t('note')}</label>
						<textarea className="form-control" rows="2"
							value={telegramModal.note}
							onChange={(e) => setTelegramModal({ ...telegramModal, note: e.target.value })} />
					</div>

					{/* Ro'yxatda FAQAT guruh adminlari (user qarori 2026-07-27).
					    Nega adminlar: Telegram botga guruhning to'liq a'zolar ro'yxatini bermaydi,
					    lekin getChatAdministrators adminlarni TO'LIQ va DARHOL beradi — ya'ni
					    bu yagona ishonchli va to'liq ro'yxat. Bo'lim rahbarlari guruhda admin
					    qilinsa, ular hech narsa yozmasdan shu ro'yxatda turadi. */}
					<div className="form-group mb-3">
						<label className="form-label">{t('tg_mention')}</label>
						{tgEmployees.length > 0 ? (
							<>
								<Select
									isMulti
									options={tgEmployees}
									value={tgEmployees.filter((e) => telegramModal.mentions.includes(e.key))}
									onChange={(opts) => setTelegramModal({ ...telegramModal, mentions: (opts ?? []).map((o) => o.key) })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									// Yorliq: «Ism (@username) — Lavozim».
									// Lavozim faqat shu odam Tameer xodimiga bog'langan bo'lsa chiqadi.
									getOptionLabel={(o) => {
										let s = o.name
										if (o.username && !String(o.name).startsWith('@')) s += ` (@${o.username})`
										if (o.position_name) s += ` — ${o.position_name}`
										return s
									}}
									getOptionValue={(o) => o.key}
								/>
								<div className="form-text">{t('tg_mention_hint')}</div>
							</>
						) : (
							<div className="text-muted" style={{ fontSize: '13px' }}>{t('tg_no_admins')}</div>
						)}
					</div>

					{/* Ko'rib chiqish — guruhga AYNAN shu ketadi */}
					<div className="border rounded p-2" style={{ maxHeight: '340px', overflow: 'auto', background: '#f8f9fa' }}>
						<div style={{ transform: 'scale(0.62)', transformOrigin: 'top left', width: '161%' }}>
							{tgData?.id && <Cheque data={tgData} show={true} />}
						</div>
					</div>
				</Modal.Body>

				<Modal.Footer>
					<button className="btn btn-warning"
						onClick={() => setTelegramModal({ show: false, item: {}, note: '', mentions: [], sending: false })}>
						{t('cancel')}
					</button>
					<button className="btn btn-primary" disabled={telegramModal.sending}
						onClick={() => sendTelegramCheque()}>
						{telegramModal.sending
							? <><span className="spinner-border spinner-border-sm me-2"></span>{t('tg_sending')}</>
							: <><i className="uil-telegram-alt me-1"></i>{t('tg_send')}</>}
					</button>
				</Modal.Footer>
			</Modal>

			<ReturnModal
				showModal={returnModal}
				setShowModal={() => toggleReturnModal(false)}
				onSuccess={() => getData()}
			/>

			{/* Chek qatoridan to'lov olish (₴) — pul darhol kassaga, chek qarzi darhol kamayadi */}
			{/* ================= TO'LOV TURINI TUZATISH (naqd ↔ bank) =================
			    Kassir naqdni adashib bankka tushirsa — smena yopishda naqd kam chiqadi.
			    SUMMA O'ZGARMAYDI, faqat tur. Faqat ochiq smena. */}
			{/* KECHIKISH SABABI — ro'yxat qat'iy, chunki bu bo'yicha hisobot chiqadi */}
			<Modal show={lateModal.show} animation={false} centered
				onHide={() => setLateModal({ show: false, item: {}, reason: '', note: '' })}>
				<Modal.Header closeButton>
					<Modal.Title>Kechikish sababi</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex flex-column gap-2">
						{lateReasons.map((r) => (
							<label key={r.id} className={'d-flex align-items-center gap-2 p-2 rounded border ' +
								(lateModal.reason === r.id ? 'border-primary' : '')}
								style={{ cursor: 'pointer' }}>
								<input type="radio" name="late_reason" checked={lateModal.reason === r.id}
									onChange={() => setLateModal({ ...lateModal, reason: r.id })} />
								<span>{r.name}</span>
							</label>
						))}
					</div>
					<div className="form-group mt-3">
						<label>Izoh (ixtiyoriy)</label>
						<textarea className="form-control" rows="2" value={lateModal.note}
							onChange={(e) => setLateModal({ ...lateModal, note: e.target.value })} />
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-warning"
						onClick={() => setLateModal({ show: false, item: {}, reason: '', note: '' })}>
						{t('cancel')}
					</button>
					<button className="btn btn-primary" onClick={saveLate}>{t('save')}</button>
				</Modal.Footer>
			</Modal>

			<Modal show={fixTypeModal.show} animation={false} centered onHide={() => toggleFixTypeModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('fix_payment_type')} — {t('cheque')} №{fixTypeModal.item?.id}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="alert alert-light border py-2 mb-3" style={{ fontSize: '13px' }}>
						<i className="uil uil-info-circle me-1"></i>{t('fix_payment_type_hint')}
					</div>

					{fixTypeRows.length === 0 ? (
						<div className="text-muted" style={{ fontSize: '13px' }}>{t('list_empty')}</div>
					) : (
						<>
							{/* 1) Qaysi to'lov — aralash to'lovda bir nechta bo'lishi mumkin */}
							<div className="form-group mb-3">
								<label className="form-label">{t('payment')}</label>
								{fixTypeRows.map((row) => (
									<div key={row.id}
										className={`p-2 mb-2 rounded d-flex justify-content-between align-items-center${row.can_fix ? '' : ' opacity-50'}`}
										style={{
											background: fixTypeSelected?.id === row.id ? '#e7f1ff' : '#f8f9fa',
											border: fixTypeSelected?.id === row.id ? '1px solid #86b7fe' : '1px solid #e9ecef',
											cursor: row.can_fix ? 'pointer' : 'not-allowed',
										}}
										onClick={() => row.can_fix && selectFixTypeRow(row)}>
										<div>
											<div className="fw-600">{formatMoney(row.amount)}</div>
											<div className="text-muted" style={{ fontSize: '12px' }}>
												{row.payment_type_name} · {formatDate(row.created_at, 'dd.MM.yyyy HH:mm')}
											</div>
										</div>
										{/* Yopilgan smenaga tegishli to'lov tuzatilmaydi (1-bosqich) */}
										{!row.can_fix &&
											<span className="text-danger" style={{ fontSize: '11.5px' }}>
												{t('fix_payment_type_closed_shift')}
											</span>
										}
									</div>
								))}
							</div>

							{/* 2) Yangi tur — faqat naqd/bank (cashPaymentTypes allaqachon shunday filtrlangan) */}
							<div className="form-group mb-3">
								<label className="form-label">{t('fix_payment_type_new')}<span className="required-mark">*</span></label>
								<Select
									options={cashPaymentTypes.filter((p) => Number(p.id) !== Number(fixTypeSelected?.payment_type_id))}
									value={fixTypeNewPt}
									onChange={(o) => setFixTypeNewPt(o)}
									isDisabled={!fixTypeSelected}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(o) => o.name}
									getOptionValue={(o) => o.id}
								/>
							</div>

							{/* 3) KO'CHIRILADIGAN SUMMA. To'liq bo'lsa tur almashadi; kichik bo'lsa
							    to'lov BO'LINADI (2 700 000 naqd -> 2 000 000 naqd + 700 000 Click).
							    Jami summa har holda o'zgarmaydi. */}
							<div className="form-group mb-3">
								<label className="form-label">{t('fix_payment_type_amount')}<span className="required-mark">*</span></label>
								<div className="input-group">
									<input type="text" className="form-control text-end fw-600"
										style={{ fontSize: '17px' }}
										disabled={!fixTypeSelected}
										value={formatMoneyInput(fixTypeAmount ?? '')}
										onChange={(e) => setFixTypeAmount(e.target.value.replace(/[^\d]/g, ''))} />
									<button type="button" className="btn btn-outline-primary text-nowrap"
										disabled={!fixTypeSelected}
										onClick={() => setFixTypeAmount(String(Math.round(fixTypeMax)))}>
										{t('all')}
									</button>
								</div>
								{fixTypeSelected && fixTypeMoved > fixTypeMax ? (
									<div className="form-text text-danger">
										{t('fix_payment_type_too_much')}: {formatMoney(fixTypeMax)}
									</div>
								) : fixTypeSelected && fixTypeRest > 0 ? (
									/* Bo'lish holati — natija oldindan ko'rinadi */
									<div className="form-text">
										{fixTypeSelected.payment_type_name} {formatMoney(fixTypeRest)}
										{' + '}
										{fixTypeNewPt ? fixTypeNewPt.name : '...'} {formatMoney(fixTypeMoved)}
									</div>
								) : (
									<div className="form-text">{t('fix_payment_type_amount_hint')}</div>
								)}
							</div>

							{/* 4) Izoh MAJBURIY — audit_log ga yoziladi, kim nega tuzatganini bilish uchun */}
							<div className="form-group mb-0">
								<label className="form-label">{t('note')}<span className="required-mark">*</span></label>
								<textarea className="form-control" rows="2"
									value={fixTypeNote}
									onChange={(e) => setFixTypeNote(e.target.value)} />
								<div className="form-text">{t('fix_payment_type_note_hint')}</div>
							</div>
						</>
					)}
				</Modal.Body>
				<Modal.Footer>
					<button type="button" className="btn btn-warning me-2" onClick={() => toggleFixTypeModal(false)}>
						{t('cancel')}
					</button>
					<button type="button" className="btn btn-primary"
						disabled={fixTypeSubmitting || !fixTypeValid}
						onClick={() => submitFixType()}>
						{fixTypeSubmitting
							? <><span className="spinner-border spinner-border-sm me-1"></span>{t('save')}</>
							: t('save')}
					</button>
				</Modal.Footer>
			</Modal>

			<Modal show={paymentModal.show} animation={false} centered onHide={() => togglePaymentModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('take_payment')} — {t('cheque')} №{paymentModal.item?.id}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex justify-content-between mb-1">
						<span className="text-muted">{t('client')}</span>
						<span className="fw-600">{paymentModal.item?.client_name || '—'}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span className="text-muted">{t('amount')}</span>
						<span className="fw-600">{formatMoney(getChequeTotalAmount(paymentModal.item))}</span>
					</div>
					<div className="d-flex justify-content-between mb-3">
						<span className="text-muted">{t('paid')}</span>
						<span className="fw-600">{formatMoney(getChequePaidAmount(paymentModal.item))}</span>
					</div>

					<div className="p-3 mb-3 rounded text-center" style={{ background: '#fdecea', color: '#c0392b' }}>
						<div className="text-uppercase" style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '.06em' }}>
							{t('not_paid')}
						</div>
						<div style={{ fontSize: '24px', fontWeight: 700 }}>
							{formatMoney(paymentDebt)}
						</div>
					</div>

					{/* ARALASH TO'LOV: har bir tur uchun alohida summa.
					    Masalan: Накд 50 000 + Банк 100 000 + P2P 50 000 = 200 000 */}
					{cashPaymentTypes.map((pt, i) => (
						<div className="form-group mb-2" key={pt.id}>
							<label>{pt.name}</label>
							<div className="input-group">
								<input type="text" className="form-control text-end fw-600"
									autoFocus={i === 0} style={{ fontSize: '17px' }}
									value={formatMoneyInput(paymentAmounts[pt.id] ?? '')}
									onChange={(e) => setPaymentAmounts({
										...paymentAmounts,
										[pt.id]: e.target.value.replace(/[^\d]/g, ''),
									})} />
								<button type="button" className="btn btn-outline-primary text-nowrap"
									onClick={() => fillRemaining(pt.id)}>
									{t('all')}
								</button>
							</div>
						</div>
					))}

					{/* Chegirma  kassir qarzning mayda qismini kechirishi mumkin (pul EMAS, qarzni yopadi) */}
					<div className="form-group mb-2">
						<label>{t('discount')}</label>
						<input type="text" className="form-control text-end fw-600"
							style={{ fontSize: '17px' }}
							value={formatMoneyInput(paymentDiscount ?? '')}
							onChange={(e) => setPaymentDiscount(e.target.value.replace(/[^\d]/g, ''))} />
					</div>

					{/* Jonli hisob: kiritilgan / qoldi */}
					<div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
						<span className="text-muted">{t('paid')}</span>
						<span className="fw-600">{formatMoney(paymentEntered)}</span>
					</div>
					<div className="p-2 mt-2 rounded text-center" style={
						paymentLeft > 0 ? { background: '#fdf4e3', color: '#b7791f' }
							: paymentLeft < 0 ? { background: '#fdecea', color: '#c0392b' }
								: { background: '#e6f5ee', color: '#1f7a54' }
					}>
						<span className="fw-600">
							{paymentLeft > 0 && `${t('remainder')}: ${formatMoney(paymentLeft)}`}
							{paymentLeft === 0 && (paymentEntered > 0 || paymentDiscountNum > 0) && `✓ ${t('fully_paid')}`}
							{paymentLeft === 0 && paymentEntered === 0 && paymentDiscountNum === 0 && `${t('remainder')}: ${formatMoney(paymentDebt)}`}
							{paymentLeft < 0 && `${t('amount_exceeds_debt')} (+${formatMoney(-paymentLeft)})`}
						</span>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-outline-warning" onClick={() => togglePaymentModal(false)}>
						{t('cancel')}
					</button>
					<button className="btn btn-primary"
						disabled={paymentSubmitting || (paymentEntered + paymentDiscountNum) <= 0 || paymentLeft < 0}
						onClick={() => submitPayment()}>
						{t('take_payment')}{paymentEntered > 0 ? ` — ${formatMoney(paymentEntered)}` : ''}
					</button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default Index
